import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const CheckCircle = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color6.hex,
    description = t('ds.icon.checkCircle.description'),
    dmId = 'dm-check-circle-filled',
    pointerEvents = 'none',
    secondColor = theme.palette.color5.hex,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.checkCircle.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps
  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <circle fill={color} cx="12" cy="12" r="10" />
      <path
        fill={secondColor}
        d="m10.462 15.77a1 1 0 0 1 -.707-.293l-2.462-2.462a1 1 0 1 1 1.414-1.415l1.755 1.754 4.831-4.832a1 1 0 1 1 1.414 1.415l-5.538 5.539a1 1 0 0 1 -.707.294z"
      />
    </IconSvg>
  );
};

export default memo(CheckCircle);
